const LOYALTY_BONUS_RULE_APPLICABLE_PRODUCT_TYPES: Array<App.LoyaltyBonusRuleApplicableProductType> = [
  'rental',
  'lux_plus',
  'cruise_group_1',
  'cruise_group_2',
  'cruise_group_3',
  'hotel_flash',
  'hotel_lpc',
  'hotel_lpp_eps',
  'tour_bank',
  'trusted_partner_tour',
  'le_tour',
  'car_hire',
  'int_economy',
  'int_premium_economy',
  'int_business',
  'int_first',
  'dom_economy',
  'dom_business',
  'experience',
]

const LOYALTY_BONUS_RULE_APPLICABLE_PRODUCT_TYPES_SET = new Set<string>(LOYALTY_BONUS_RULE_APPLICABLE_PRODUCT_TYPES)

function isLoyaltyProductTypeBonusApplicable(productType: App.LoyaltyProductType): productType is App.LoyaltyBonusRuleApplicableProductType {
  return LOYALTY_BONUS_RULE_APPLICABLE_PRODUCT_TYPES_SET.has(productType)
}

export default isLoyaltyProductTypeBonusApplicable
